import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PopupModal from '../popupModal/PopupModal';
import elementBtn from '../../../assets/FinalStage/elementBtn.png';
import classes from './FinalistsListButton.module.css';

const FinalistsListButton = ({ className, showFinalistsListPopup, text }) => {

  const { texts } = useSelector((state) => state.translate);
  const { contentInfoJson } = useSelector((state) => state.contest);
  const [showPopup, setShowPopup] = useState(false);

  const handleClick = () => {
    setShowPopup(true);
  }

  return (
    <>
      {showFinalistsListPopup ?
        <button className={className || classes.finalistsButton} onClick={handleClick} >
          <img src={elementBtn} alt="" className={classes.finalistsButtonDecoLeft} aria-hidden />
          <span className={classes.finalistsButtonText}>{texts[contentInfoJson?.final?.finalInfo.btnText]}</span>
          <img src={elementBtn} alt="" className={classes.finalistsButtonDecoRight} aria-hidden />
        </button>
        :
        <p className={className || classes.noHavefinalistsListText}>{texts.noHavefinalistsListText}</p>
      }
      {showPopup && <PopupModal url={contentInfoJson?.final?.studentListUrl} onClose={() => setShowPopup(false)} />}
    </>
  )
}

export default FinalistsListButton;
